const AgentHrActionTypes = {
  SET_INDEX: "SET_INDEX",
  SET_CONTAINER: "SET_CONTAINER",
  SET_INDEX_OBJ: "SET_INDEX_OBJ",
  SET_THEME: "SET_THEME",
};

export default AgentHrActionTypes;
